import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';
import Calendar from 'react-calendar';
import {
  radius,
  defaultColor,
  companyColor,
  font,
  device,
  fluidFont,
} from 'styles/theme';
import { FormControlStlyes } from '../styles';

export const PickerMenu = styled(animated.div)`
  background-color: ${defaultColor('white')};
  border-radius: ${radius('small')};
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 1rem;
  z-index: 10;
`;

export const Box = styled.div`
  position: relative;
`;

// Tiles that are neither the selected range nor today, which keep their own colours.
const plainTile = '.react-calendar__tile:not(.react-calendar__tile--active):not(.react-calendar__tile--hasActive)';

export const CalendarBox = styled(Calendar)`
  &.react-calendar {
    border-radius: ${radius('small')};
    border-color: ${companyColor('font')};
    width: 100%;

    @media only screen and (${device('tablet')}) {
      width: 350px;
    }
  }
  .react-calendar__month-view__days {
    height: 320px;

    @media only screen and (${device('tablet')}) {
      height: auto;
    }
  }
  .react-calendar__tile,
  .react-calendar__navigation__label {
    font-family: ${font('semibold')};
  }
  .react-calendar__month-view__weekdays {
    font-family: ${font('bold')};
    color: ${companyColor('font')};
  }

  .react-calendar__navigation {
    &__label {
      color: ${companyColor('font')};
    }
    &__prev2-button {
      border-top-left-radius: ${radius('small')};
    }
    &__next2-button {
      border-top-right-radius: ${radius('small')};
    }
  }

  .react-calendar__tile {
    &--now {
      background: transparent;
      color: ${companyColor('main')};
    }

    &--active,
    &--hasActive {
      background: ${companyColor('main')};
      color: ${defaultColor('white')};
      &:hover {
        background: ${companyColor('main', 0.75)};
      }
      &:enabled:focus {
        background: ${companyColor('main')};
      }
    }
  }

  /* react-calendar ships its own light palette (white panel, #f0f0f0 tiles); repaint it on the dark surface. */
  ${({ theme }) => theme.isDark && css`
    &.react-calendar {
      background: ${defaultColor('white')};
      border-color: ${defaultColor('background')};
    }

    .react-calendar__navigation button,
    ${plainTile}:not(.react-calendar__tile--now) {
      color: ${companyColor('font')};
    }

    .react-calendar__navigation button:disabled,
    .react-calendar__tile:disabled {
      background-color: transparent;
      opacity: 0.35;
    }

    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus,
    ${plainTile}:enabled:hover,
    ${plainTile}:enabled:focus {
      background-color: rgba(255, 255, 255, 0.08);
    }

    .react-calendar__month-view__days__day--neighboringMonth {
      opacity: 0.5;
    }
  `}
`;

export const Input = styled.input`
  ${FormControlStlyes};
`;

export const ErrorMessage = styled.div`
    display: block;
    position: absolute;
    font-family: ${font('regular')};
    ${fluidFont('11px', '12px')};
    color: ${defaultColor('red')};
    top: 100%;
    left: 0;
    width: 100%;
    margin-top: 4px;
`;
